import { cn } from "@/lib/utils";

export function Tabs({ tabs, value, onChange, id }) {
  return (
    <div className="mb-5 flex w-fit max-w-full gap-1 overflow-x-auto rounded-full bg-muted p-1" role="tablist" data-testid={`${id}-tabs`}>
      {tabs.map(([k, label]) => (
        <button key={k} role="tab" aria-selected={value === k} onClick={() => onChange(k)} data-testid={`${id}-tab-${k}`} className={cn("whitespace-nowrap rounded-full px-3 py-1.5 text-sm font-medium transition-colors", value === k ? "bg-card text-primary border border-border" : "text-muted-foreground hover:text-foreground")}>{label}</button>
      ))}
    </div>
  );
}
